import { render, staticRenderFns } from "./AMAfa.vue?vue&type=template&id=7cb78eb8&scoped=true"
import script from "./AMAfa.vue?vue&type=script&lang=ts"
export * from "./AMAfa.vue?vue&type=script&lang=ts"
import style0 from "./AMAfa.vue?vue&type=style&index=0&id=7cb78eb8&prod&lang=scss&scoped=true"
import style1 from "./AMAfa.vue?vue&type=style&index=1&id=7cb78eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb78eb8",
  null
  
)

export default component.exports